export default function setPageTitle(title) {
    document.title = `${title} - School portal`;
}